import React from 'react';
import location from './location_grey.svg'

const Location_grey = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={location} />
  )
};

export default Location_grey;
